import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, MakeEgdsSizingLength } from 'uitk-react-utils';
import { setElementFocus, hasSheetClassName, setFocus, defineSheetLayout, trapUpperBoundFocus, trapLowerBoundFocus } from './uitk-sheet-utilities.esm.js';
import styles from './uitk-sheet.css';

var getClassNameList = classNames.bind(styles);
var UitkBottomSheet = function (props) {
    var _a, _b;
    var _c = props.autoFocus, autoFocus = _c === void 0 ? true : _c, children = props.children, className = props.className, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, hasModal = props.hasModal, isExpanded = props.isExpanded, _e = props.returnFocusOnClose, returnFocusOnClose = _e === void 0 ? true : _e, isVisible = props.isVisible, triggerRef = props.triggerRef, _f = props.type, type = _f === void 0 ? 'bottom' : _f, height = props.height, attributes = __rest(props, ["autoFocus", "children", "className", "fullWidth", "hasModal", "isExpanded", "returnFocusOnClose", "isVisible", "triggerRef", "type", "height"]);
    var sheetRef = React.useRef(null);
    var baseClassName = "uitk-".concat(type, "-sheet");
    var sheetClassNames = getClassNameList(baseClassName, (_a = {},
        _a["".concat(baseClassName, "-full-width")] = fullWidth,
        _a["".concat(baseClassName, "-expanded")] = isExpanded,
        _a), className);
    var sheetStyles = __assign({}, (height && (_b = {},
        _b["--uitk-bottom-sheet-height"] = "".concat(MakeEgdsSizingLength(height)),
        _b)));
    // Set focus when mount and/or update
    React.useEffect(function () {
        if (autoFocus && isVisible) {
            setElementFocus(sheetRef, true, hasModal);
        }
        hasModal && hasSheetClassName('add');
    }, [autoFocus, isVisible, hasModal, isExpanded]);
    // "unmount" hook
    React.useEffect(function () { return function () {
        if (returnFocusOnClose) {
            setFocus(triggerRef);
        }
        hasModal && hasSheetClassName('remove');
    }; }, [hasModal, isVisible, returnFocusOnClose, triggerRef]);
    var _g = defineSheetLayout(children), hasCloseButton = _g.hasCloseButton, layoutProps = _g.layoutProps, closeButtonLayoutProps = _g.closeButtonLayoutProps, closeButtonElem = _g.closeButtonElem, childrenElem = _g.childrenElem;
    return (React.createElement("section", __assign({ ref: sheetRef, className: sheetClassNames, tabIndex: -1, style: sheetStyles }, attributes),
        hasModal && React.createElement("div", { tabIndex: 0, onFocus: trapUpperBoundFocus, "aria-hidden": "true" }),
        hasCloseButton && (React.createElement(UitkLayoutFlex, __assign({}, layoutProps),
            React.createElement(UitkLayoutFlexItem, __assign({}, closeButtonLayoutProps),
                React.createElement("div", null, closeButtonElem)),
            childrenElem && React.createElement(UitkLayoutFlexItem, null, childrenElem))),
        !hasCloseButton && childrenElem,
        hasModal && React.createElement("div", { tabIndex: 0, onFocus: trapLowerBoundFocus, "aria-hidden": "true" })));
};
UitkBottomSheet.displayName = 'UitkBottomSheet';

export { UitkBottomSheet };
